import { useContext } from 'react';
import { DealRevenueModifiersContext } from '../context';

export const useDealRevenueModifiers = () => {
  const context = useContext(DealRevenueModifiersContext);

  if (!context) {
    throw new Error('Hook "useDealRevenueModifiers" must be used within the "DealRevenueModifiersContext".');
  }

  return context;
};
